export default __webpack_public_path__ + "static/media/dating2.a247789f.png";